import React, { useEffect, useContext } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Flaky as FlakyIcon,
} from '@mui/icons-material/';

function ModalPapirGameFinishedWithoutPrize() {
  const { t } = useTranslation();

  const {
    updateFocusOnMainScreen,
    updateShowModalPapirGameFinishedWithoutPrize,
    updateIsLoadingScreen,
    papirScannedInfo,
    updateShowModalPapirCheckCard,
    updatePapirCardInfo,
    updatePapirScannedInfo,
  } = useContext(AppContext);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    console.log('ModalPapirGameFinishedWithoutPrize mounted', papirScannedInfo);
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handleGetPapirCardInfo = async (data) => {
      console.log('data getPapirCardInfo', data);
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirCardInfo(data);
      updateShowModalPapirCheckCard(true);
    };

    socket.on('getPapirCardInfo', handleGetPapirCardInfo);
    return () => {
      socket.off('getPapirCardInfo', handleGetPapirCardInfo);
    };
  }, [socket]);

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const confirmClose = async () => {
    updateFocusOnMainScreen(true);
    updatePapirScannedInfo(false);

    updateShowModalPapirGameFinishedWithoutPrize(false);
  };

  const handleCheckCard = async () => {
    updateIsLoadingScreen(true);
    socket.emit('getPapirCardInfo', {
      bingoName: papirScannedInfo.bingoName,
      gameID: papirScannedInfo.gameID,
      ticketID: papirScannedInfo.ticketID,
    });
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>{t('sales.papirGameFinishedWithoutPrizeTitle')} </h1>
            <p>{t('sales.papirGameFinishedWithoutPrizeText1')}</p>
            <p>{t('sales.papirGameFinishedWithoutPrizeText2')}</p>
            <div
              className="react-confirm-alert-button-group"
              style={{ marginTop: '55px' }}
            >
              <button
                className="btn-custom-yes"
                onClick={() => {
                  confirmClose();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                }}
              >
                <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                {t('sales.confirm')}
              </button>

              <button
                className="btn-custom-yes-and-stay"
                onClick={() => {
                  handleCheckCard();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                }}
              >
                <FlakyIcon style={{ fontSize: '1.2em' }} />

                {t('sales.checkCard')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalPapirGameFinishedWithoutPrize;
